import React from 'react';
import '../assets/css/Projects.css'; 
import ProjectItem from './pages/ProjectItem';

const ProjectGrid = (props) =>
{
    const projects = props.projects.map((project) => 
    {
        return (
            <ProjectItem
                className="Project-Item"
                key={ project.id }
                project={ project }
            />
        );
    });

    return (
        <div className="Project-Grid">
            { projects }
        </div>
    );
}

export default ProjectGrid;